import React, { useState, useContext, useReducer } from 'react';

export const MinitabContext = React.createContext();
